// extracted by mini-css-extract-plugin
export default {"pills":"TopicPills-module__pills--Z9bYd","child":"TopicPills-module__child--bw2t5","more":"TopicPills-module__more--ZErv0"};